const animeConfig = {
    username: "Puppyz4nx", // Replace with your actual AniList username
    defaultType: "ANIME", // ANIME or MANGA
};

export default animeConfig;
